var getPost = function (state, userId, postId) {
    return state.getIn(['post', 'userPosts', userId, postId]);
};
export var postSelector = {
    getPost: getPost
};



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/posts/postSelector.ts
// module id = 294
// module chunks = 50